<template>
  <vx-card v-if="useCard" style="width:calc(100% - 40px)">
    <component :is="component"/>
  </vx-card>
  <div v-else>
    <component :is="component"/>
  </div>
</template>

<script>
import breadcrumb from '@/views/boards/tab/breadcrumb'
export default {
  name: 'Page',
  components:{
    'singlePage100': () => import('@/views/boards/single-page/100/Write'),
    'singlePage101': () => import('@/views/boards/single-page/101/Write'),
    'singlePage102': () => import('@/views/boards/single-page/102/Write'),
    'singlePage103': () => import('@/views/boards/single-page/103/Write'),
    'singlePage104': () => import('@/views/boards/single-page/104/Write'),
    'singlePage105': () => import('@/views/boards/single-page/105/Write'),
    'singlePage106': () => import('@/views/boards/single-page/106/Viewer'),
    'singlePage107': () => import('@/views/boards/single-page/107/Write'),
    'singlePage108': () => import('@/views/boards/single-page/108/Write'),
    'singlePage109': () => import('@/views/boards/single-page/109/Write'),
    'singlePage110': () => import('@/views/boards/single-page/110/Write'),
    'singlePage111': () => import('@/views/boards/single-page/111/Write'),
    'singlePage112': () => import('@/views/boards/single-page/112/Write'),
    'singlePage113': () => import('@/views/boards/single-page/113/Write'),
    'singlePage114': () => import('@/views/boards/single-page/114/Write'),
    'singlePage115': () => import('@/views/boards/single-page/115/Write'),
    'singlePage116': () => import('@/views/boards/single-page/116/Write'),
    'singlePage117': () => import('@/views/boards/single-page/117/Write'),
    'singlePage118': () => import('@/views/boards/single-page/118/Write'),
    'singlePage119': () => import('@/views/boards/single-page/119/Write'),
    'singlePage120': () => import('@/views/boards/single-page/120/Write'),
    'singlePage121': () => import('@/views/boards/single-page/121/Write'),
    'singlePage122': () => import('@/views/boards/single-page/122/Write'),
    'singlePage123': () => import('@/views/boards/single-page/123/Write'),
    'singlePage124': () => import('@/views/boards/single-page/124/Write'),
    'singlePage125': () => import('@/views/boards/single-page/125/Write'),
    'singlePage126': () => import('@/views/boards/single-page/126/Write'),
    'singlePage127': () => import('@/views/boards/single-page/127/Write'),
    'singlePage128': () => import('@/views/boards/single-page/128/Write'),
    'singlePage129': () => import('@/views/boards/single-page/129/Write'),
    'singlePage130': () => import('@/views/boards/single-page/130/Write'),
    'singlePage131': () => import('@/views/boards/single-page/131/Write'),
    'singlePage132': () => import('@/views/boards/single-page/132/Write'),
    'singlePage133': () => import('@/views/boards/single-page/133/Write'),
    'singlePage134': () => import('@/views/boards/single-page/134/Write'),
    'singlePage135': () => import('@/views/boards/single-page/135/Write'),
    'singlePage136': () => import('@/views/boards/single-page/136/Write'),
    'singlePage137': () => import('@/views/boards/single-page/137/Write'),
    'singlePage138': () => import('@/views/boards/single-page/138/Write'),
    'singlePage139': () => import('@/views/boards/single-page/139/Write'),
    'singlePage140': () => import('@/views/boards/single-page/140/Write'),
    'singlePage141': () => import('@/views/boards/single-page/141/Write'),
    'singlePage142': () => import('@/views/boards/single-page/142/Write'),
    'singlePage143': () => import('@/views/boards/single-page/143/Write'),
    'singlePage144': () => import('@/views/boards/single-page/144/Write'),
    'singlePage145': () => import('@/views/boards/single-page/145/Write'),
    'singlePage146': () => import('@/views/boards/single-page/146/Write'),
    'singlePage147': () => import('@/views/boards/single-page/147/Write'),
    'singlePage148': () => import('@/views/boards/single-page/148/Write'),
    'singlePage149': () => import('@/views/boards/single-page/149/Write'),
    'singlePage150': () => import('@/views/boards/single-page/150/Write'),
    'singlePage151': () => import('@/views/boards/single-page/151/Write'),
    'singlePage152': () => import('@/views/boards/single-page/152/Write'),
    'singlePage153': () => import('@/views/boards/single-page/153/Write'),
    'singlePage154': () => import('@/views/boards/single-page/154/Viewer'),
    'singlePage155': () => import('@/views/boards/single-page/155/Viewer'),
    'singlePage156': () => import('@/views/boards/single-page/156/Write'),
    'singlePage157': () => import('@/views/boards/single-page/157/Write'),
    'singlePage158': () => import('@/views/boards/single-page/158/Write'),
    'singlePage159': () => import('@/views/boards/single-page/159/Write'),
    'singlePage160': () => import('@/views/boards/single-page/160/Write'),
    'singlePage161': () => import('@/views/boards/single-page/161/Write'),
    'singlePage162': () => import('@/views/boards/single-page/162/Write'),
    'singlePage163': () => import('@/views/boards/single-page/163/Write'),
    'singlePage164': () => import('@/views/boards/single-page/164/Write'),
    'singlePage165': () => import('@/views/boards/single-page/165/Write'),
    'singlePage166': () => import('@/views/boards/single-page/166/Write'),
    'singlePage167': () => import('@/views/boards/single-page/167/Write'),
    'singlePage168': () => import('@/views/boards/single-page/168/Write'),
    'singlePage169': () => import('@/views/boards/single-page/169/Write'),
    'singlePage170': () => import('@/views/boards/single-page/170/Write'),
    'singlePage171': () => import('@/views/boards/single-page/171/Write'),
    'singlePage172': () => import('@/views/boards/single-page/172/Write'),
    'singlePage173': () => import('@/views/boards/single-page/173/Write'),
    'singlePage174': () => import('@/views/boards/single-page/174/Write'),
    'singlePage175': () => import('@/views/boards/single-page/175/Write'),
    'singlePage176': () => import('@/views/boards/single-page/176/Write'),
    'singlePage177': () => import('@/views/boards/single-page/177/Write'),
    'singlePage178': () => import('@/views/boards/single-page/178/Write'),
    'singlePage179': () => import('@/views/boards/single-page/179/Write'),
    'singlePage180': () => import('@/views/boards/single-page/180/Write'),
    'singlePage181': () => import('@/views/boards/single-page/181/Write'),
    'singlePage182': () => import('@/views/boards/single-page/182/Write'),
    'singlePage183': () => import('@/views/boards/single-page/183/Write'),
    'singlePage184': () => import('@/views/boards/single-page/184/Write'),
    'singlePage185': () => import('@/views/boards/single-page/185/Write'),
    'singlePage186': () => import('@/views/boards/single-page/186/Write'),
    'singlePage187': () => import('@/views/boards/single-page/187/Write'),
    'singlePage188': () => import('@/views/boards/single-page/188/Write'),
    'singlePage189': () => import('@/views/boards/single-page/189/Write'),
    'singlePage190': () => import('@/views/boards/single-page/190/Write'),
    'singlePage191': () => import('@/views/boards/single-page/191/Write'),
    'singlePage192': () => import('@/views/boards/single-page/192/Write'),
    'singlePage193': () => import('@/views/boards/single-page/193/Write'),
    'singlePage194': () => import('@/views/boards/single-page/194/Write'),
    'singlePage195': () => import('@/views/boards/single-page/195/Write'),
    'singlePage196': () => import('@/views/boards/single-page/196/Write'),
    'singlePage197': () => import('@/views/boards/single-page/197/Write'),
    'singlePage198': () => import('@/views/boards/single-page/198/Write'),
    'singlePage199': () => import('@/views/boards/single-page/199/Write'),
    'singlePage200': () => import('@/views/boards/single-page/200/Write'),
    'singlePage201': () => import('@/views/boards/single-page/201/Write'),
    'singlePage202': () => import('@/views/boards/single-page/202/Write'),
    'singlePage203': () => import('@/views/boards/single-page/203/Write'),
    'singlePage204': () => import('@/views/boards/single-page/204/Write'),
    'singlePage205': () => import('@/views/boards/single-page/205/Write'),
    'singlePage206': () => import('@/views/boards/single-page/206/Write'),
    'singlePage207': () => import('@/views/boards/single-page/207/Write'),
    'singlePage208': () => import('@/views/boards/single-page/208/Write'),
    'singlePage209': () => import('@/views/boards/single-page/209/Write'),
    'singlePage210': () => import('@/views/boards/single-page/210/Write'),
    'singlePage211': () => import('@/views/boards/single-page/211/Write'),
    'singlePage212': () => import('@/views/boards/single-page/212/Write'),
    'singlePage213': () => import('@/views/boards/single-page/213/Write'),
    'singlePage214': () => import('@/views/boards/single-page/214/Write'),
    'singlePage215': () => import('@/views/boards/single-page/215/Write'),
    'singlePage216': () => import('@/views/boards/single-page/216/Write'),
    'singlePage217': () => import('@/views/boards/single-page/217/Write'),
    'singlePage218': () => import('@/views/boards/single-page/218/Write'),
    'singlePage219': () => import('@/views/boards/single-page/219/Write'),
    'singlePage220': () => import('@/views/boards/single-page/220/Write'),
    'singlePage221': () => import('@/views/boards/single-page/221/Write'),
    'singlePage222': () => import('@/views/boards/single-page/222/Write'),
    'singlePage223': () => import('@/views/boards/single-page/223/Write'),
    'singlePage224': () => import('@/views/boards/single-page/224/Write'),
    'singlePage225': () => import('@/views/boards/single-page/225/Write'),
    'singlePage226': () => import('@/views/boards/single-page/226/Write'),
    'singlePage227': () => import('@/views/boards/single-page/227/Write'),
    'singlePage228': () => import('@/views/boards/single-page/228/Write'),
    'singlePage229': () => import('@/views/boards/single-page/229/Write'),
    'singlePage230': () => import('@/views/boards/single-page/230/Write'),
    'singlePage231': () => import('@/views/boards/single-page/231/Write'),
    'singlePage232': () => import('@/views/boards/single-page/232/Write'),
    'singlePage233': () => import('@/views/boards/single-page/233/Write'),
    'singlePage234': () => import('@/views/boards/single-page/234/Write'),
    'singlePage235': () => import('@/views/boards/single-page/235/Write'),
    'singlePage236': () => import('@/views/boards/single-page/236/Write'),
    'singlePage237': () => import('@/views/boards/single-page/237/Write'),
    'singlePage238': () => import('@/views/boards/single-page/238/Write'),
    'singlePage239': () => import('@/views/boards/single-page/239/Write'),
    'singlePage240': () => import('@/views/boards/single-page/240/Write'),
    'singlePage241': () => import('@/views/boards/single-page/241/Write'),
    'singlePage242': () => import('@/views/boards/single-page/242/Write'),
    'singlePage243': () => import('@/views/boards/single-page/243/Write'),
    'singlePage244': () => import('@/views/boards/single-page/244/Write'),
    'singlePage245': () => import('@/views/boards/single-page/245/Write'),
    'singlePage246': () => import('@/views/boards/single-page/246/Write'),
    'singlePage247': () => import('@/views/boards/single-page/247/Write'),
    'singlePage248': () => import('@/views/boards/single-page/248/Write'),
    'singlePage249': () => import('@/views/boards/single-page/249/Write'),
    'singlePage250': () => import('@/views/boards/single-page/250/Write'),
    'singlePage251': () => import('@/views/boards/single-page/251/Write'),
    'singlePage252': () => import('@/views/boards/single-page/252/Write'),
    'singlePage253': () => import('@/views/boards/single-page/253/Write'),
    'singlePage254': () => import('@/views/boards/single-page/254/Write'),
    'singlePage255': () => import('@/views/boards/single-page/255/Write'),
    'singlePage256': () => import('@/views/boards/single-page/256/Write'),
    'singlePage257': () => import('@/views/boards/single-page/257/Write'),
    'singlePage258': () => import('@/views/boards/single-page/258/Write'),
    'singlePage259': () => import('@/views/boards/single-page/259/Write'),
    'singlePage260': () => import('@/views/boards/single-page/260/Write'),
    'singlePage261': () => import('@/views/boards/single-page/261/Write'),
    'singlePage262': () => import('@/views/boards/single-page/262/Write'),
    'singlePage263': () => import('@/views/boards/single-page/263/Write'),
    'singlePage264': () => import('@/views/boards/single-page/264/Write'),
    'singlePage265': () => import('@/views/boards/single-page/265/Write'),
    'singlePage266': () => import('@/views/boards/single-page/266/Write'),
    'singlePage267': () => import('@/views/boards/single-page/267/Write'),
    'singlePage268': () => import('@/views/boards/single-page/268/Write'),
    'singlePage269': () => import('@/views/boards/single-page/269/Write'),
    'singlePage270': () => import('@/views/boards/single-page/270/Write'),
    'singlePage271': () => import('@/views/boards/single-page/271/Write'),
    'singlePage272': () => import('@/views/boards/single-page/272/Write'),
    'singlePage273': () => import('@/views/boards/single-page/273/Write'),
    'singlePage274': () => import('@/views/boards/single-page/274/Write'),
    'singlePage275': () => import('@/views/boards/single-page/275/Write'),
    'singlePage276': () => import('@/views/boards/single-page/276/Write'),
    'singlePage277': () => import('@/views/boards/single-page/277/Write'),
    'singlePage278': () => import('@/views/boards/single-page/278/Write'),
    'singlePage279': () => import('@/views/boards/single-page/279/Write'),
    'singlePage280': () => import('@/views/boards/single-page/280/Write'),
    'singlePage281': () => import('@/views/boards/single-page/281/Write'),
    'singlePage282': () => import('@/views/boards/single-page/282/Write'),
    'singlePage283': () => import('@/views/boards/single-page/283/Write'),
    'singlePage284': () => import('@/views/boards/single-page/284/Write'),
    'singlePage285': () => import('@/views/boards/single-page/285/Write'),
    'singlePage286': () => import('@/views/boards/single-page/286/Write'),
    'singlePage287': () => import('@/views/boards/single-page/287/Write'),
    'singlePage288': () => import('@/views/boards/single-page/288/Write'),
    'singlePage289': () => import('@/views/boards/single-page/289/Write'),
    'singlePage290': () => import('@/views/boards/single-page/290/Write'),
    'singlePage291': () => import('@/views/boards/single-page/291/Write'),
    'singlePage292': () => import('@/views/boards/single-page/292/Write'),
    'singlePage293': () => import('@/views/boards/single-page/293/Write'),
    'singlePage294': () => import('@/views/boards/single-page/294/Write'),
    'singlePage295': () => import('@/views/boards/single-page/295/Write'),
    'singlePage296': () => import('@/views/boards/single-page/296/Write'),
    'singlePage297': () => import('@/views/boards/single-page/297/Write'),
    'singlePage298': () => import('@/views/boards/single-page/298/Write'),
    'singlePage299': () => import('@/views/boards/single-page/299/Write'),
    'singlePage300': () => import('@/views/boards/single-page/300/Write'),
    'singlePage301': () => import('@/views/boards/single-page/301/Write'),
    'singlePage302': () => import('@/views/boards/single-page/302/Write'),
    'singlePage303': () => import('@/views/boards/single-page/303/Write'),
    'singlePage304': () => import('@/views/boards/single-page/304/Write'),
    'singlePage305': () => import('@/views/boards/single-page/305/Write'),
    'singlePage306': () => import('@/views/boards/single-page/306/Write'),
    'singlePage307': () => import('@/views/boards/single-page/307/Write'),
    'singlePage308': () => import('@/views/boards/single-page/308/Write'),
    'singlePage309': () => import('@/views/boards/single-page/309/Write'),
    'singlePage310': () => import('@/views/boards/single-page/310/Write'),
    'singlePage311': () => import('@/views/boards/single-page/311/Write'),
    'singlePage312': () => import('@/views/boards/single-page/312/Write'),
    'singlePage313': () => import('@/views/boards/single-page/313/Write'),
    'singlePage314': () => import('@/views/boards/single-page/314/Write'),
    'singlePage315': () => import('@/views/boards/single-page/315/Write'),
    'singlePage316': () => import('@/views/boards/single-page/316/Write'),
    'singlePage317': () => import('@/views/boards/single-page/317/Write'),
    'singlePage318': () => import('@/views/boards/single-page/318/Write'),
    'singlePage319': () => import('@/views/boards/single-page/319/Write'),
    'singlePage320': () => import('@/views/boards/single-page/320/Write'),
    'singlePage321': () => import('@/views/boards/single-page/321/Write'),
    'singlePage322': () => import('@/views/boards/single-page/322/Write'),
    'singlePage323': () => import('@/views/boards/single-page/323/Write'),
    'singlePage324': () => import('@/views/boards/single-page/324/Write'),
    'singlePage325': () => import('@/views/boards/single-page/325/Write'),
    'singlePage326': () => import('@/views/boards/single-page/326/Write'),
    'singlePage327': () => import('@/views/boards/single-page/327/Write'),
    'singlePage328': () => import('@/views/boards/single-page/328/Write'),
    'singlePage329': () => import('@/views/boards/single-page/329/Write'),
    'singlePage330': () => import('@/views/boards/single-page/330/Write'),
    'singlePage337': () => import('@/views/boards/single-page/337/Write'),
    'singlePage338': () => import('@/views/boards/single-page/338/Write'),

    'singlePage345': () => import('@/views/boards/single-page/345/Write'),
    'singlePage346': () => import('@/views/boards/single-page/346/Write'),

    'singlePage352': () => import('@/views/boards/single-page/352/Write'),
    'singlePage353': () => import('@/views/boards/single-page/353/Write'),
    'singlePage354': () => import('@/views/boards/single-page/354/Write'),

    'singlePage358': () => import('@/views/boards/single-page/358/Write'),

    'singlePage361': () => import('@/views/boards/single-page/361/Viewer'),
    'singlePage362': () => import('@/views/boards/single-page/362/Write'),
    'singlePage363': () => import('@/views/boards/single-page/363/Write'),
    'singlePage364': () => import('@/views/boards/single-page/364/Write'),
    'singlePage365': () => import('@/views/boards/single-page/365/Write'),
    'singlePage366': () => import('@/views/boards/single-page/366/Write'),
    'singlePage367': () => import('@/views/boards/single-page/367/Write'),
    'singlePage368': () => import('@/views/boards/single-page/368/Write'),
    'singlePage369': () => import('@/views/boards/single-page/369/Write'),
    'singlePage370': () => import('@/views/boards/single-page/370/Write'),

    'singlePage372': () => import('@/views/boards/single-page/372/Write'),

    'singlePage377': () => import('@/views/boards/single-page/377/Write'),
    'singlePage378': () => import('@/views/boards/single-page/378/Write'),
  },
  computed: {
    boardId () {
      /*
       * 같은 그룹으로 묶은 subMenu 들 중에, 게시판 번호가 동일한 문서가 있을 경우
       * 두 메뉴가 동시에 활성화되는 문제를 방지하기 위해
       * page 문서는 게시판 번호 앞에 _ 기호를 붙이도록 하여
       * 다른 boardId로 인식되도록 하고
       * Page.vue 에서도 예외적으로 진입할 수 있도록 하였음
       */
      const routeBoardId = this.$route.params.boardId;
      if(routeBoardId.indexOf('_') < 0) {
        return parseInt(routeBoardId);
      }

      const split = routeBoardId.split('_');
      return parseInt(split[1])
    },
    component () {
      return `singlePage${this.boardId}`
    },
    useCard () {
      if (this.boardId === 132) {
        return false
      }
      return true
    }
  },
  data () {
    return {
      breadcrumb,
    }
  },
  beforeMount () {
    this.initBreadcrumb()
  },
  methods: {
    initBreadcrumb () {
      let breadcrumb = [{title: 'Home'}]
      breadcrumb.push(...this.breadcrumb[`${this.boardId}`])

      if (Number(`${this.projectId}`) === 1) {
        if (this.boardId === 119) {
          breadcrumb = [{title: 'Home'}, {title: '사업장 등록'}, {title: '안전보건관리책임자 지정 외'}]
        } else if (this.boardId === 120) {
          breadcrumb = [{title: 'Home'}, {title: '사업장 등록'}, {title: '중대재해예방팀 선임'}]
        } else if (this.boardId === 121) {
          breadcrumb = [{title: 'Home'}, {title: '사업장 등록'}, {title: '안전보건조정자 선임'}]
        } else if (this.boardId === 122) {
          breadcrumb = [{title: 'Home'}, {title: '사업장 등록'}, {title: '안전보건관리자 및 산업보건의 선임'}]
        } else if (this.boardId === 123) {
          breadcrumb = [{title: 'Home'}, {title: '사업장 등록'}, {title: '안전보건관리자 및 산업보건의(건설업) 선임'}]
        }/* else if (this.boardId === 124) {
          breadcrumb = [{title: 'Home'}, {title: '사업장 등록'}, {title: '안전보건담당자 선임'}]
        }*/ else if (this.boardId === 125) {
          breadcrumb = [{title: 'Home'}, {title: '사업장 등록'}, {title: '관리감독자 선임'}]
        }
      }

      if (breadcrumb.length > 0) breadcrumb[breadcrumb.length - 1].active = true
      this.$store.commit('menu/UPDATE_PAGE_LIST', breadcrumb)
    },
  }
}
</script>

<style scoped>

</style>
